import { Grid } from "@chakra-ui/react";
import dayjs from "dayjs";
import { CustomBox, CustomText } from "./currentDates.style";
import { type CurrentDateProps } from "./currentDates.type";

export const CurrentDates = ({ calendar, title, ...rest }: CurrentDateProps) => {
    const { year, month } = title;
    const { checkIn, checkOut, currentObj, onChangeColor, maxDate, onNavigate } = rest;

    return (
        <Grid gridTemplateColumns="repeat(7, 1fr)" rowGap="8px">
            {calendar?.map((calendar, index) => {
                const keyProp = index;
                const date = calendar.date > 0 && calendar.date;
                const comparisonDate = `${year}-${month.toString().padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
                const getTimeComparisonDate = dayjs(comparisonDate).valueOf();
                const isCurrentDateValid = getTimeComparisonDate < currentObj.valueOf();
                const isCheckIn = checkIn === comparisonDate;
                const isCheckOut = checkOut === comparisonDate;
                const isBetween =
                    dayjs(checkIn).valueOf() < getTimeComparisonDate &&
                    dayjs(checkOut).valueOf() > getTimeComparisonDate;

                return (
                    <CustomBox
                        key={keyProp}
                        onClick={() => !isCurrentDateValid && onChangeColor(comparisonDate, onNavigate)}
                        className={isCurrentDateValid ? "low_than_today" : ""}
                        isCheckIn={isCheckIn}
                        isCheckOut={isCheckOut}
                        isBetween={isBetween}
                    >
                        <CustomText
                            w="100%"
                            h="100%"
                            isCheckIn={isCheckIn}
                            isCheckOut={isCheckOut}
                            isBetween={isBetween}
                            weekDayNum={dayjs(comparisonDate).day()}
                            isMaxValid={maxDate && maxDate.valueOf() < getTimeComparisonDate}
                        >
                            {date}
                        </CustomText>
                    </CustomBox>
                );
            })}
        </Grid>
    );
};
